module.exports = __webpack_public_path__ + "static/img/knowledgenew.988d23f0.png";